import React from "react";
import { Progress, Button, Tag, Picker, Toast } from "antd-mobile";
import { withRouter } from "react-router-dom";
import GoBack from "../../components/GoBack";
import "./PositionInfo.scss";
import http from "../../util/api.js";
const resid = 617195632278;

class PositionInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      jobStatus: [],
      data: {},
      dataInfo: {
        tags: ""
      },
      positionMsg: []
    };
  }

  // 数据初始化完成，请求数据
  componentDidMount() {
    const id = this.props.match.params.id;
    window.V5CHAT("hideBtn");
    this.getPositionMsg(id);

    // this.setState({
    //   dataInfo: this.props.location.state.data
    // });
    // 清除缓存
    // http().clearCache();
    // this.onSearch();
  }

  // 获取职位信息
  getPositionMsg = async id => {
    try {
      let res = await http().getPublicTable({
        resid,
        cmswhere: `jobId = '${id}'`
      });
      let { data } = res;
      if (data.data.length) {
        this.setState({ dataInfo: data.data[0] });
        Toast.hide();
      } else {
        Toast.info("无职位信息", 2, () => {
          this.props.history.push("/home");
        });
      }
    } catch (error) {
      console.log(error.message);
      Toast.fail(error.message);
    }
  };

  // 查询职位信息
  onSearch = async () => {
    let res;
    try {
      res = await http().getTable({
        resid: resid
      });
      console.log("res", res);
      this.setState({ jobStatus: res.data.data });
      // if(res.ErrorMsg === ""){
      // }
    } catch (error) {
      console.log(error);
    }
  };

  handleClick = () => {
    if (
      this.state.dataInfo.C3_617389097930 !==
      this.state.dataInfo.C3_617389077304
    ) {
      this.props.history.push({
        pathname: "/appointment_position/" + this.state.dataInfo.REC_ID,
        state: {
          data: this.state.dataInfo
        }
      });
    }
  };

  goBack = () => {
    this.props.history.push("/home");
  };
  renderPositionInfos() {
    let tags = this.state.dataInfo.tags;
    let tags1 = tags.split(",");
    return (
      <div className="position_infos">
        <GoBack goBack={this.goBack} />
        <div className="position_infos-intro">
          <div className="position_infos-intro-top">
            <div className="position_name">{this.state.dataInfo.jobName}</div>
            <div className="position_percent">
              {/* <Progress
                style={{ width: "100%", borderRadius: "0.25rem" }}
                percent={50}
                position="normal"
              /> */}
              <Progress
                className={
                  this.state.dataInfo.C3_617389097930 ===
                  this.state.dataInfo.C3_617389077304
                    ? "progress-full"
                    : "am-progress-bar"
                }
                // className=  {item.isActivated === 'Y' ? (item.C3_617389097930 === item.C3_617389077304) ? 'progress-full' : 'am-progress-bar'}
                percent={
                  this.state.dataInfo.isActivated === "Y"
                    ? (this.state.dataInfo.C3_617389097930 * 100) /
                      this.state.dataInfo.C3_617389077304
                    : 0
                }
                position="normal"
                unfilled={true}
                style={{
                  backgroundColor: "#DDDDDD",
                  marginRight: "10%",
                  width: "100%",
                  border: "1px solid rgba(221,221,221,1)",
                  minHeight: ".5rem",
                  borderRadius: "999px"
                }}
              />
            </div>
          </div>
          <div className="position_infos-intro-bottom">
            <div
              className="position_salary"
              style={{
                color:
                  this.state.dataInfo.isActivated === "Y"
                    ? this.state.dataInfo.C3_617389097930 ===
                      this.state.dataInfo.C3_617389077304
                      ? "#F4333C"
                      : "#1098EC"
                    : "#BBB"
              }}
            >
              {this.state.dataInfo.salary}/月
            </div>
            <div className="position_status">
              {this.state.dataInfo.C3_617389097930 ===
              this.state.dataInfo.C3_617389077304 ? (
                <span style={{ color: "#F4333C" }}>
                  {this.state.dataInfo.C3_617389097930}/
                  {this.state.dataInfo.C3_617389077304}
                </span>
              ) : (
                <span>
                  {this.state.dataInfo.C3_617389097930}/
                  {this.state.dataInfo.C3_617389077304}
                </span>
              )}
              {/* <span>{this.state.dataInfo.C3_617389097930}/{this.state.dataInfo.C3_617389077304}</span> */}
              {this.state.dataInfo.C3_617389097930 ===
              this.state.dataInfo.C3_617389077304 ? (
                <span style={{ color: "#F4333C" }}>已爆满</span>
              ) : (
                <span>可报名</span>
              )}
            </div>
          </div>
        </div>
        <div className="position_infos-position_description">
          <header>
            <span className="description_title">职位描述</span>
            <span className="compare_to">对比其他企业</span>
          </header>
          <div className="descrption_main">
            <p className="job_content">{this.state.dataInfo.jobDis}</p>
            <div className="position_tags">
              {tags1.map((item, index) => {
                return <Tag key={index}>{item}</Tag>;
              })}
            </div>
          </div>
          <div className="order_btn">
            <Button
              className="order"
              type="primary"
              // onClick={() => {
              //   this.props.history.push("/appointment_position")
              // }}
              onClick={this.handleClick.bind(this)}
              style={{
                backgroundColor:
                  this.state.dataInfo.C3_617389097930 ===
                  this.state.dataInfo.C3_617389077304
                    ? "#DDDDDD"
                    : "#108EE9",
                color:
                  this.state.dataInfo.C3_617389097930 ===
                  this.state.dataInfo.C3_617389077304
                    ? "#BBB"
                    : "#FFF",
                border: "0px"
              }}
            >
              我要预约
            </Button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return this.renderPositionInfos();
  }
}

export default withRouter(PositionInfo);
